module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-en7.f7f1280.png";